import Fetch from "./Fetch";

class SeoHelper {
	static replaceVariables(text) {
		if (!text) {
			return;
		}
		const preview = document.querySelector('.diagnoseo-preview');
		const {site, siteTagline, separator, excerpt, postTitle} = preview.dataset;

		text = text.replaceAll('%title%', window.wp && window.wp.data ? window.wp.data.select('core/editor').getEditedPostAttribute('title') : postTitle);
		text = text.replaceAll('%sitename%', site);
		text = text.replaceAll('%tagline%', siteTagline);
		text = text.replaceAll('%sep%', separator);
		text = text.replaceAll('%page%', ' ');
		text = text.replaceAll('%excerpt%', excerpt);
		text = text.replaceAll('%currentyear%', new Date().getFullYear());
		text = text.replaceAll('%currentmonth%', new Date().toLocaleString('default', { month: 'long' }));

		return text;
	}

	static unmarkText(text = '') {
		let markup;
		if (text) {
			markup = document.createElement('div');
			markup.innerHTML = text;
		} else {
			markup = document.querySelector('.tiptap');
		}

		const markedElements = markup.querySelectorAll('.mark');
		markedElements.forEach((el) => {
			el.classList.remove('mark');
		});
		const elements = markup.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, td, blockquote');
		const marks = markup.querySelectorAll('mark');
		if (marks.length) {
			elements.forEach((el) => {
				el.innerHTML = el.innerHTML.replaceAll('<mark>','');
				el.innerHTML = el.innerHTML.replaceAll('</mark>','');
			});
		}

		return markup.innerHTML;
	}

	static async getTop10SearchResults(keyword, languageCode, location = 'United States') {
		if (!keyword) {
			return [];
		}
		const result = await Fetch.post(`https://${window.location.hostname}/tools/api/get-top10-results.php`, {
			keyword: keyword,
			language_name: languageCode,
			location: location,
		});
		return result.status === 'ok' ? result.urls : [];
	}

	static async getPageStats(url, keyword, relatedKeywords = []) {

		const result = await Fetch.post(`https://${window.location.hostname}/tools/content/ajax/get-page-element-count.php`, {
			url: url,
			keyword: keyword,
		});
		return result.status === 'ok' ? result.data : {};
	}

	static async getPageMarkup(url, useGooglebot = false, country = 'us') {
		const result = await Fetch.post(`https://${window.location.hostname}/tools/api/get-page-html.php`, {
			pageUrl: url,
			country: country,
			googlebot: useGooglebot ? 1 : 0,
		});

		return result;
	}

	static avg(array) {
		if (!array.length) {
			return 0;
		}
		let sum = 0;
		array.forEach((item) => {
			sum += parseInt(item);
		});

		let average = sum / array.length;
		average = parseFloat(average.toFixed(2));
		return average;
	}

	static fetchData(url, requestBody, errorMsg = 'Server error') {
		return new Promise((resolve) => {
			fetch(url, {
				method: 'POST',
				cache: 'no-cache',
				body: requestBody,
			})
			.then((response) => {
				if (response.status < 400) {
					let json = {};
					try {
						json = response.json();
					} catch(err) {
						console.error(err);
						resolve({
							status: 'error',
							message: errorMsg,
						});
						return {
							status: 'error',
						}
					}
					return json;
				} else {
					return {
						status: 'error',
					}
				}

			})
			.then((respData) => {
				resolve(respData);
			})
			.catch((error) => {
				console.error(error);
				resolve({
					status: 'error',
					message: errorMsg,
				});
			});
		})
	}

	static async fetchSearchVolume(keywords, language) {
		const result = await Fetch.post(`https://${window.location.hostname}/tools/api/get-search-volume.php`, {
			phrases: keywords,
			language: language,
		});
		return result;
	}

	static async translate(phrase, aiModel, language = 'english') {
		const translated = await Fetch.post(`https://${window.location.hostname}/tools/content/ajax/translate.php`, {
			phrase: phrase,
			language: language,
			aiModel: aiModel,
		});
		return translated.status === 'ok' ? translated.text : '';
	}
}

export default SeoHelper;